//import apiClient from "../../../../services/apiClient"

import { getFiles, getFilesToDelete, getFilesToUpload, debugFileStructures } from "./getFiles";

import { formatAddress, createAddressObj } from "./address";
import { KindergartensPage } from "../../../kindergartens/list";


const prepDictionary = (data)=>{

  const arrAddrIds = {
    district:{},
    street:{},
    building:{},
    corpus:{}
  }

  const { addresses } = data.dictionary;

  [data.child.address, data.child.addressFact, data.applicant.address, data.benefits.address].forEach(a=>{


    const d = Object.keys(addresses.district).filter(r=>r == a.district)[0];
    const s = Object.keys(addresses.street).filter(r=>r == a.street)[0];
    const b = Object.keys(addresses.building).filter(r=>r == a.building)[0];
    const c = addresses.corpus && Object.keys(addresses.corpus).filter(r=>r == a.corpus)[0] || '';

    if(d) arrAddrIds.district[d] = addresses.district[d];
    if(s) arrAddrIds.street[s] = addresses.street[s];
    if(b) arrAddrIds.building[b] = addresses.building[b];
    if(c) arrAddrIds.corpus[c] = addresses.corpus[c];

  });

  return (JSON.stringify({ addresses: arrAddrIds, Kindergartens:{} }));

}

export function prepData(data){

    const { child, applicant, preferences, benefits, selectedSchools, dictionary } = data;

    const files = getFiles(data);

    const passport = {
          "type": applicant.documentType || null, 
          "number": applicant.documentDetails || null
   };

   const outObj = {
  "responsiblePerson": {
    "contacts": {
      "phone": applicant.phone,
      "email": applicant.email,
      "address": formatAddress(applicant.address, dictionary.addresses)
    },
    "relationDegree": "Мати",
    "firstName": applicant.firstName,
    "lastName": applicant.lastName,
    "middleName": applicant.middleName,
    "code": applicant.rnokpp,
    "citizenship": applicant.citizenship == "Україна" ? 'ua': 'other',
    "benefits": [],
    "typeOfDoc": applicant.documentType || "code",
    "documentDetails": applicant.documentDetails,
    "hasRnokpp": applicant.hasRnokpp,
    "addressDict": applicant.address
  },
  "child": {
    "birthCertificate": {
      "number": child.birthCertificate.seriesNumber,
      "issueDate": child.birthCertificate.issueDate,
      "issueCountry": child.birthCertificate.country,
    },
    "illnesses": [],
    "firstName": child.firstName,
    "lastName": child.lastName,
    "middleName": child.middleName,
    "birthDate": child.birthDate,
    "gender": child.gender,
    "address": formatAddress(child.address, dictionary.addresses),
    "addressDicYur": child.address,
    "addressDicFact": child.addressFact,
    "sameFactAddress": child.sameFactAddress,
    "benefits": [
      {
        "benefitId": benefits.type,
        "documentNumber": benefits.documentNumber,
        "documentIssueDate": benefits.issueDate,
        "documentType": benefits.documentType,
        "documentTo": benefits.issuedTo,
        "kindergartenId": benefits.kindergarten,
        "address": createAddressObj(benefits.address),
      }
    ]
  },
  "neededPlaceDescription": {
    "inclusive": preferences.inclusiveGroup ? "yes" : "no"
  },
  "criterias": [
    {
      "values": selectedSchools,
      "key": "kindergartenId"
    }
  ],
  "languageTraining": "ua",
  "preferDateFrom": preferences.desiredDate,
  "specialization": {
    "specializationId": preferences.diseaseType,
    "dateFrom": preferences.diseaseDocument.issueDate,
    "dateTo": null,
    "medicalProtocol": preferences.diseaseDocument.number,
    "medicalProtocolDate": null,
    "issueTo": preferences.diseaseDocument.issuedTo,
    "typeOfDoc": preferences.diseaseDocument.type,
  },
  "youngerGroup": preferences.ageMenu ? "yes" : "no",
  "dictionary": prepDictionary(data)
};

if(applicant.documentType) outObj['responsiblePerson']['passport'] = passport;

return ({outObj, files});
 
}

// Новая функция для подготовки данных при обновлении
export function prepUpdateData(newData, originalData) {

  debugFileStructures(newData, originalData);

  const { outObj } = prepData(newData);
  
  // Определяем файлы для удаления
  const filesToDelete = getFilesToDelete(newData, originalData);
  
  // Определяем файлы для загрузки (только измененные)
  const filesToUpload = getFilesToUpload(newData, originalData);
  
  return { 
    outObj, 
    files: filesToUpload, // Загружаем только измененные файлы
    filesToDelete 
  };
}

export const deepClone = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (obj instanceof Date) return new Date(obj);
  if (obj instanceof Array) return obj.map(item => deepClone(item));
  if (obj instanceof Object) {
    const clonedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = deepClone(obj[key]);
      }
    }
    return clonedObj;
  }
};